import React from "react";
import PaymentReportRow, { CELL_STYLE, SimpleStatusCell, mapPaymentReports } from "./PaymentReportRow";
import { getStatusDates, pickStatusDate } from "./paymentDates";

export default function CheckPaymentList(props) {
    return (
        <>
            {mapPaymentReports(props.data, props.offset, props.limit, (report) => (
                <TableRow
                    program={report.program}
                    patientID={report.patient_id}
                    firstName={report.first_name}
                    lastName={report.last_name}
                    dob={report.date_of_birth}
                    memberNum={report.member_id}
                    dos={report.date_of_service}
                    claimData={report.claim_data}
                    amount={parseFloat(report.claim_data.program_benefit).toFixed(2)}
                    checkNum={report.claim_data.check_num}
                    status={report.claim_status}
                />
            ))}
        </>
    );
}

function TableRow(props) {
    const dates = getStatusDates(props.claimData, props.dos);

    return (
        <PaymentReportRow
            {...props}
            statusDate={pickStatusDate(dates)}
            idCell={<td style={CELL_STYLE}>{props.checkNum}</td>}
            statusCell={<SimpleStatusCell paidDate={dates.paid_date} status={props.status} />}
        />
    );
}


